import React from "react";
import "./loader.css";
const Loader = () => {
  return <div id="loader" className="nfLoader"></div>;
};

export default Loader;
